import React from 'react';
import classnames from 'classnames';
import styles from "./overviewLayout.module.less";
import SearchBar from "@/components/SearchBar/SearchBar";
import treeSelectStyles from "@/components/TreeSelect/darkTreeSelect.module.less"
import selectStyles from "@/components/Select/darkSelect.module.less"
/**
 * 这是个基于boot对antd封装的table再次封装的CRUDLayout组件，
 * 用来解决繁琐的基本操作,将业务逻辑放到调用的组件。
 */
class OverviewLayout extends React.PureComponent {
    state = {
        mainRef: undefined,
    }
    render() {
        const { children, columns, toolBarButtonGroup, title, onSearch, theme, unQuery } = this.props
        const { mainRef } = this.state
        const searchMiniBarProps = { columns, theme, appendLeft: toolBarButtonGroup, onSearch: onSearch, appendTo: mainRef };
        let searchBarCount = columns.filter(f1 => f1.searchItem && f1.searchItem.group && (f1.searchItem.group === `advance` || f1.searchItem.group === `mini`));
        return (
            <div className={classnames(styles.crudMain, treeSelectStyles.treeSelectPopupContainer, selectStyles.selectPopupContainer)}
                ref={ref => {
                    if (ref && !mainRef) {
                        this.setState({ mainRef: ref })
                    }
                }}
            >
                <div className={styles.title}>{title}</div>
                {((searchBarCount && searchBarCount.length > 0) || toolBarButtonGroup) && !unQuery ?
                    <div className={styles.searchBarDiv}><SearchBar {...searchMiniBarProps} /></div>
                    : ``
                }
                <div className={styles.body}>
                    {children}
                </div>
            </div>
        );
    }
}
export default OverviewLayout